import { TIME_VALUES } from '~/Constants/Date.constants';

export const TIME_WIDTH = 45;
export const MARGIN_BETWEEN_EVENTS = 5;
export const TIME_TABLE_OFFSET_TOP = 7;
export const EVENT_OFFSET_TOP = 2;

export const DRAGGABLE_EVENT_TIME_STEP_IN_MINUTES = 5; // every 5 minutes
export const NEW_EVENT_TIME_STEP_IN_MINUTES = 30; // every 30 minutes
export const DAYS_IN_WEEK = 7;

export const EVENT_Z_INDEX = 1;
export const TIME_STEPS_NUMBER_PER_DAY = 96;
export const TIME_STEP = TIME_VALUES.DAY / TIME_STEPS_NUMBER_PER_DAY;
export const FULL_DAY_ACTIVITY_HEIGHT = 20;

export const MINUTES_IN_DAY = 24 * 60;
export const HOURS_IN_DAY = 24;
export const MIN_CALENDAR_EVENT_HEIGHT = 34;

export enum EditEventOption {
  SINGLE_EVENT = 'single event',
  EVENT_SERIES = 'event series',
}
